<form class="register" [formGroup]="formGroup!" autocomplete="off" data-testid="change-pw-container">
  @if (!passwordChangeSuccess) {
    <app-modal-option-panel>

      <div class="modal-option-panel__stack">
        <div class="input-el flex-column">
          <label>{{ languageService.languageJSON.AccountDialog_ActualPassword }}</label>
          <span class="pw-span">
            <div class="password-field">
              <input name="old-password" required autocomplete="off" class="password-input"
                data-testid="change-pw-actual-input"
                [placeholder]="languageService.languageJSON.Global_Password"
                formControlName="actualPassword" [type]="showActualPassword ? 'text' : 'password'">
              <button type="button" class="password-toggle"
                data-testid="change-pw-actual-toggle-btn"
                [ngClass]="showActualPassword ? 'password-eye-off' : 'password-eye-on'"
                (click)="toggleActualPassword()" tabindex="-1"
                aria-label="Toggle password visibility"></button>
            </div>
          </span>
          @if (actualPassword.invalid && actualPassword.touched) {
            <h6 class="invalid">{{ languageService.languageJSON.AccountDialog_ActualPassword_Invalid }}</h6>
          }
          @if (invalidActualPassword) {
            <h6 class="invalid">{{ languageService.languageJSON.AccountDialog_ActualPassword_Error }}</h6>
          }
        </div>

        <div class="input-el flex-column">
          <label>{{ languageService.languageJSON.AccountDialog_NewPassword }}</label>
          <span class="pw-span">
            <div class="password-field">
              <input name="new-password" required autocomplete="new-password" class="password-input"
                data-testid="change-pw-new-input"
                [placeholder]="languageService.languageJSON.Global_Password"
                formControlName="newPassword" [type]="showNewPassword ? 'text' : 'password'">
              <button type="button" class="password-toggle"
                data-testid="change-pw-new-toggle-btn"
                [ngClass]="showNewPassword ? 'password-eye-off' : 'password-eye-on'"
                (click)="toggleNewPassword()" tabindex="-1"
                aria-label="Toggle password visibility"></button>
            </div>
          </span>
          @if (newPassword.invalid && newPassword.touched) {
            <h6 class="invalid">{{ languageService.languageJSON.AccountDialog_Password_Invalid }}</h6>
          }
        </div>

        <div class="input-el flex-column">
          <label>{{ languageService.languageJSON.AccountDialog_NewPasswordConfirmation }}</label>
          <span class="pw-span">
            <div class="password-field">
              <input required name="new-password" autocomplete="new-password" class="password-input"
                data-testid="change-pw-confirm-input"
                [placeholder]="languageService.languageJSON.Global_PasswordConfirmation"
                formControlName="newPasswordConfirmation"
                [type]="showNewPasswordConfirmation ? 'text' : 'password'">
              <button type="button" class="password-toggle"
                data-testid="change-pw-confirm-toggle-btn"
                [ngClass]="showNewPasswordConfirmation ? 'password-eye-off' : 'password-eye-on'"
                (click)="toggleNewPasswordConfirmation()" tabindex="-1"
                aria-label="Toggle password visibility"></button>
            </div>
          </span>
          <span class="error-container">
            @if (newPasswordConfirmation.invalid && newPasswordConfirmation.touched) {
              <h6 class="invalid">{{ languageService.languageJSON.AccountDialog_Password_Invalid }}</h6>
            }
            @if (newPasswordsMatch) {
              <h6 class="invalid">{{ languageService.languageJSON.AccountDialog_Password_NotMatch }}</h6>
            }
          </span>
        </div>
      </div>
    </app-modal-option-panel>
  }

  @if (passwordChangeSuccess) {
    <app-modal-option-panel>
      <div class="input-el flex-column">
        <div class="succ-icon">
          <img
            [src]="'/assets/icons/' + settingsService.getMap().Skin + '/ui/registration_icon_success.svg'" />
        </div>
        <h3>{{ languageService.languageJSON.AccountDialog_Success }}</h3>
        <h5 class="h5-succ">{{ languageService.languageJSON.AccountDialog_PasswordChanged }}</h5>
      </div>
    </app-modal-option-panel>
  }
</form>
